module.exports = __webpack_public_path__ + "static/nothic-46a09973e5dde15d338f1f1f01ea7903.png";